

















import { Component, Vue } from 'vue-property-decorator';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
})
export default class Pager extends Vue {
  @Prop(Number)
  readonly totalPages!: number;

  @Prop(Number)
  readonly currentPage!: number;

  get pageRange(): number[] {
    return [...Array(this.totalPages).keys()];
  }

  onPageClicked(event: Event, number: number) {
    event.preventDefault();
    this.$emit('page-clicked', number);
  }
}
